import { Rhythm, Meta, Song, Homework, Settings, Session } from '../models';

export const GAME_MODES = {
  play: 'play',
  record: 'record',
  review: 'review',
};

export const INPUT_MODES = {
  key: 'key',
  jog: 'jog',
  gym: 'gym',
};

export const FALL_SPEED = {
  default: 0.26,
  min: 0.1,
  max: 0.42,
  step: 0.08,
};

export const DEFAULT_META: Meta = {
  source: '',
  bpm: 60,
};

export const DEFAULT_SONG: Song = {
  ...DEFAULT_META,
  title: '',
  artist: '',
  rhythms: [],
};

export const DEFAULT_RHYTHM: Rhythm = {
  name: '',
  timings: [],
};

export const DEFAULT_HOMEWORK: Homework = {
  title: '',
  problems: [],
};

export const DEFAULT_SETTINGS: Settings = {
  songIdx: -1,
  song: DEFAULT_SONG,
  rhythm: DEFAULT_RHYTHM,
  homework: DEFAULT_HOMEWORK,
  velocity: FALL_SPEED.default,
  randomize: false,
  inputMode: '',
  whichPadLabels: 'hiragana',
  guidance: false,
};

export const DEFAULT_SESSION: Session = {
  songIdx: -1,
  rhythmIdx: -1,
  velocity: FALL_SPEED.default,
  duration: 0,
  videoStartTime: 0,
  videoEndTime: 0,
  song: DEFAULT_SONG,
  rhythm: DEFAULT_RHYTHM,
  precision: 1,
};
